module.exports = __webpack_public_path__ + "img/layers-3.4dea92b1.svg";